import { LitElement } from '@lit'
import { t } from '@nova/utils'

class NovaCustomCalculator extends LitElement {
  constructor() {
    super()

    this.inquiryForm = document.querySelector('.js-special-shape-inquiry-form')
    this._handleUnitType = this._handleUnitType.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this._initializeElements()
    this._handleUnitType()
    this._addEventListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this._removeEventListeners()
  }

  _initializeElements() {
    this.unitTypeElem = this.querySelector('.js-custom-size-unit-type')
    this.unitValuesElem = this.querySelector('nova-custom-calculator-values')
    this.shapeElemValue = document.querySelector('[name="shape"]:checked')?.value || 'rectangle'
    this.sizeElem = document.querySelector('[name="size"]:checked')
    this.submitBtn = document.querySelector('.js-product-buy-button')
  }

  _addEventListeners() {
    this.unitTypeElem.addEventListener('sl-change', this._handleUnitType)

    document.addEventListener(
      'nova:product:render-custom-calculator',
      this._handleVariantPickerUpdate,
    )

    document.addEventListener(
      'changeQuantityStarted',
      this._handleChangeQty,
    )
  }

  _removeEventListeners() {
    this.unitTypeElem.removeEventListener('sl-change', this._handleUnitType)

    document.removeEventListener(
      'nova:product:render-custom-calculator',
      this._handleVariantPickerUpdate,
    )

    document.removeEventListener(
      'changeQuantityStarted',
      this._handleChangeQty,
    )
  }

  _handleVariantPickerUpdate = (event) => {
    this.updateContent(event.detail.html)
  }

  _handleChangeQty(event) {
    const { value } = event.detail
    const qty = Number(value) || 1
    this.querySelector('nova-custom-calculator-values').setAttribute('qty', qty)
  }

  updateContent(content) {
    if (!content) return
    // Clear existing children
    while (this.firstChild) {
      this.removeChild(this.firstChild)
    }
    // Append new children
    while (content.firstChild) {
      this.appendChild(content.firstChild)
    }
    this.requestUpdate()

    this._initializeElements()
    this._handleUnitType()
    this._addEventListeners()
  }

  _handleUnitType() {
    if (this.shapeElemValue && this.unitTypeElem && this.sizeElem) {
      this.unitValuesElem.shape = this.shapeElemValue
      this.unitValuesElem.unitType = this.unitTypeElem.value
      this.requestUpdate()

      const available = this.querySelector('#custom-variant-available').value
      if (this.sizeElem.value.includes('custom') && available === 'true') {
        this.classList.remove('hidden')
        this.submitBtn?.setAttribute('disabled', true)

        const estimatedDateElem = document.querySelector('.js-product-estimated-date')
        const estimatedDateTextElem = this.querySelector('.js-est-by-type')
        if (estimatedDateElem && estimatedDateTextElem) {
          estimatedDateElem.classList.remove('hidden')
          estimatedDateElem.querySelector('span').textContent = estimatedDateTextElem.textContent
        }

        const $priceElems = [
          ...document.querySelectorAll(
            '.product__info-wrapper .js-product-custom-price, .product__info-wrapper .price-item--sale',
          ),
        ]
        const $priceCompareElem = document.querySelector('.product__info-wrapper .price-item--compare')
        const $pricePercentElem = document.querySelector('.product__info-wrapper .price-item--percent')
        const $priceWrapper = document.querySelector('.product__info-wrapper .js-price')
        $priceElems.forEach(item => item.textContent = '-')
        if ($priceCompareElem) {
          $priceCompareElem.classList.add('hidden')
        }
        if ($pricePercentElem) {
          $pricePercentElem.classList.add('hidden')
        }
        if ($priceWrapper) {
          $priceWrapper.classList.add('price--custom-pending')
          $priceWrapper.classList.remove('price--custom-ready')
        }

        if (this.shapeElemValue === 'special-shape') {
          this.inquiryForm.classList.remove('hidden')
        } else {
          this.inquiryForm.classList.add('hidden')
        }
      } else {
        const $priceWrapper = document.querySelector('.product__info-wrapper .js-price')
        if ($priceWrapper) {
          $priceWrapper.classList.remove('price--custom-pending')
          $priceWrapper.classList.remove('price--custom-ready')
        }
        this.classList.add('hidden')
        if (this.submitBtn) {
          if (!this.submitBtn.hasAttribute('init-disabled')) {
            this.submitBtn?.removeAttribute('disabled')
          }
        }
      }
    }
  }

  createRenderRoot() {
    return this
  }
}

if (typeof customElements.get('nova-custom-calculator') === 'undefined') {
  customElements.define('nova-custom-calculator', NovaCustomCalculator)
}
